import videojs from "video.js";

const Plugin = videojs.getPlugin("plugin");
const Button = videojs.getComponent("Button");

class UnmuteButton extends Button {
  constructor(player, options) {
    super(player, options);
    this.controlText(player.localize("Unmute"));
    player.one("volumechange", () => {
      player.removeClass("vjs-muted-autoplay");
      this.dispose();
    });
  }

  buildCSSClass() {
    return `vjs-unmute-button ${super.buildCSSClass()}`;
  }

  handleClick() {
    this.player().muted(false);
  }
}

export class UnmutePlugin extends Plugin {
  constructor(player, options) {
    super(player, options);
    player.on("ready", () => {
      if (player.muted() && player.autoplay()) {
        player.addChild("UnmuteButton");
        player.addClass("vjs-muted-autoplay");
      }
    });
  }
}

videojs.registerComponent("UnmuteButton", UnmuteButton);
videojs.registerPlugin("unmute", UnmutePlugin);
